import {
    ADD_COUNTRY_FAILED,
    ADD_COUNTRY_LOADING,
    ADD_COUNTRY_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addNewCountryReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case ADD_COUNTRY_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_COUNTRY_SUCCESS:
            return {
                ...state,
                loading: false,
                mesg: action.payload.message,
                status: action.status,
                error: null,
            };
        case ADD_COUNTRY_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




